const toastrFileDownBtn = {
  info1: 'Wait!',
  info2: 'Your document is being generated',
  error1: 'Error!',
  error2: 'Unable to download report. Try again!'
};

export default toastrFileDownBtn;
